<div class="auth-page">
  <div class="auth-card app-card">

    <div class="auth-brand">
      <span class="material-symbols-outlined brand-icon">lock_reset</span>
      <h1 class="brand-title">{{ 'auth.forgot_title' | translate }}</h1>
      <p class="brand-sub">{{ 'auth.admin' | translate }}</p>
    </div>

    <div class="success-state" *ngIf="submitted">
      <span class="material-symbols-outlined success-icon">mark_email_read</span>
      <h3>{{ 'auth.check_inbox' | translate }}</h3>
      <p>{{ 'auth.check_inbox_sub' | translate }}</p>
      <a routerLink="/login" class="back-link">
        <span class="material-symbols-outlined">arrow_back</span> {{ 'btn.back_signin' | translate }}
      </a>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="auth-form" *ngIf="!submitted">
      <p class="form-hint">{{ 'auth.forgot_hint' | translate }}</p>

      <div class="form-group">
        <label for="fpEmail">{{ 'lbl.email_address' | translate }}</label>
        <input
          formControlName="email"
          id="fpEmail"
          type="email"
          class="form-control themed-input"
          [placeholder]="'ph.email' | translate"
          autocomplete="email"
        />
        <span class="field-error" *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
          {{ 'err.email_required' | translate }}
        </span>
      </div>

      <button type="submit" class="auth-btn" [disabled]="loading">
        <span class="btn-spinner" *ngIf="loading"></span>
        {{ loading ? ('auth.sending' | translate) : ('btn.send_reset' | translate) }}
      </button>

      <a routerLink="/login" class="back-link">
        <span class="material-symbols-outlined">arrow_back</span> {{ 'btn.back_signin' | translate }}
      </a>
    </form>

  </div>
</div>
